(function () {
  'use strict';

  var OLD = 'social@aborderproducts.com';
  var NEW = 'support@aborderproducts.com';

  var REGIONS = [
    '.shopify-policy__body',
    '.main-page .rte',
    '.collapsible-content__popup--info',
    '.contact-form__info',
    '.footer'
  ];

  function rewriteText(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.nodeValue && node.nodeValue.indexOf(OLD) !== -1
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var hits = [];
    var n;
    while ((n = walker.nextNode())) hits.push(n);
    for (var i = 0; i < hits.length; i++) {
      hits[i].nodeValue = hits[i].nodeValue.split(OLD).join(NEW);
    }
    return hits.length;
  }

  function rewriteLinks(root) {
    // Links matter more than the visible text: a customer who clicks through
    // gets a pre-addressed message to the wrong inbox.
    var links = root.querySelectorAll('a[href*="' + OLD + '"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute(
        'href',
        links[i].getAttribute('href').split(OLD).join(NEW)
      );
    }
    return links.length;
  }

  function init() {
    for (var i = 0; i < REGIONS.length; i++) {
      var roots = document.querySelectorAll(REGIONS[i]);
      for (var j = 0; j < roots.length; j++) {
        rewriteText(roots[j]);
        rewriteLinks(roots[j]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
